import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const GoalBaby: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        // Override viewBox & strokeWidth, since this is a solid icon
        <IconSVG viewBox="0 0 20 20" strokeWidth={0} {...props}>
            <IconPath
                fill="currentColor"
                fillRule="evenodd"
                d="M5.39 13.624c1.232 0 2.234.981 2.234 2.188C7.624 17.02 6.622 18 5.389 18c-1.232 0-2.234-.98-2.234-2.188 0-1.207 1.002-2.188 2.234-2.188Zm8.131 0c1.233 0 2.235.981 2.235 2.188 0 1.207-1.002 2.188-2.235 2.188-1.232 0-2.234-.98-2.234-2.188 0-1.207 1.002-2.188 2.234-2.188Zm2.43-6.267c0 3.512-2.908 6.36-6.495 6.36-3.2 0-5.937-2.292-6.42-5.393L3 8.092h6.748V1c3.501.27 6.204 2.857 6.204 6.357Z"
                clipRule="evenodd"
                {...pathProps}
            />
        </IconSVG>
    );
};
